"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverTripTrackingDto = void 0;
class DriverTripTrackingDto {
}
exports.DriverTripTrackingDto = DriverTripTrackingDto;
//# sourceMappingURL=driver-trip-tracking.dto.js.map